import DoubleNumberInputField from "components/controls/DoubleNumberInputField";
import NumberInputField from "components/controls/NumberInputField";
import TextInputField from "components/controls/TextInputField";
import { vehicleFormClasses } from "pages/vehicle/VehicleForm";
import React from "react";
import { useSelector } from "store/hooks";
import {
  isDisabledExternal,
  isDisabledExternalOrHasBeenActivated,
} from "../../../helpers";

const FinanceTempAssistanceFields = ({
  formikProps,
  userRole,
  route,
  vehicle,
}) => {
  const { setFieldValue, handleChange, values, errors } = formikProps;
  const vehicleAppSettings = useSelector((s) => s.vehicle.vehicleAppSettings); // Add this line

  return (
    <>
      <div className={vehicleFormClasses.item}>
        <DoubleNumberInputField
          setFieldValue={setFieldValue}
          value={values?.assistanceAnnualGrossPremium}
          onChange={handleChange}
          errors={errors}
          name={"assistanceAnnualGrossPremium"}
          disabled={isDisabledExternalOrHasBeenActivated({
            vehicleAppSettings,
            route,
            vehicle,
            userRole,
          })}
          label={"bfm.vehicleForm.annualGrossPremium.label"}
          isMarked={vehicle?.fieldsUpdatedByExternalUser?.includes(
            "assistanceAnnualGrossPremium"
          )}
        />
      </div>
      <div className={vehicleFormClasses.item}>
        <DoubleNumberInputField
          setFieldValue={setFieldValue}
          value={values?.assistanceAnnualNetPremium}
          onChange={handleChange}
          errors={errors}
          name={"assistanceAnnualNetPremium"}
          disabled={isDisabledExternalOrHasBeenActivated({
            vehicleAppSettings,
            route,
            vehicle,
            userRole,
          })}
          label={"bfm.annualNetPremium.label"}
          isMarked={vehicle?.fieldsUpdatedByExternalUser?.includes(
            "assistanceAnnualNetPremium"
          )}
        />
      </div>
      <div className={vehicleFormClasses.item}>
        <NumberInputField
          setFieldValue={setFieldValue}
          value={values.assistanceSuspensionDaysLimit}
          onChange={handleChange}
          errors={errors}
          name={"assistanceSuspensionDaysLimit"}
          disabled={isDisabledExternalOrHasBeenActivated({
            vehicleAppSettings,
            route,
            vehicle,
            userRole,
          })}
          isNegativeAllowed={true}
          label={"bfm.vehicleForm.assistanceSuspensionDaysLimit.label"}
          isMarked={vehicle?.fieldsUpdatedByExternalUser?.includes(
            "assistanceSuspensionDaysLimit"
          )}
        />
      </div>
      <div className={vehicleFormClasses.fullWidthFormItem}>
        <TextInputField
          value={values.assistanceComment}
          onChange={handleChange}
          errors={errors}
          name={"assistanceComment"}
          multiline
          rows={4}
          disabled={isDisabledExternal({ vehicleAppSettings, userRole, route })}
          label={"bfm.vehicleForm.assistanceComment.label"}
          isMarked={vehicle?.fieldsUpdatedByExternalUser?.includes(
            "assistanceComment"
          )}
        />
      </div>
    </>
  );
};

export default FinanceTempAssistanceFields;
